import {PreloadingStrategy, Route} from '@angular/router';

import {Observable} from 'rxjs';
import {of as observableOf} from 'rxjs/observable/of'
export class AppCustomPreloader implements PreloadingStrategy {
//    preload(route: Route, fn: () => Observable<boolean>): Observable<boolean> {
//        return Observable.of(true).delay(1000).flatMap((_: boolean) => fn());
//    }
    preload(route: Route, load: Function): Observable<any> {
        return route.data && route.data.preload ? load() : observableOf(null);
    }
}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/AppCustomPreloader.ts